module.exports = __webpack_public_path__ + "img/sp-lp-workout@2x.e4eb92a5.jpg";